export default __webpack_public_path__ + "static/media/logo_icon.0d36e5e7.svg";